import React from 'react';
import { inject, observer } from 'mobx-react';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import format from 'date-fns/format';

import '../../styles/components/Modal.css';
import ShiftForm from '../../forms/ShiftForm';

Modal.setAppElement('#root');

export default inject('planStore')(
  observer(class NewItemModal extends React.Component {
    constructor() {
      super();
      this.closeModal = this.closeModal.bind(this);
      this.toggleOnLeave = this.toggleOnLeave.bind(this);
    }

    closeModal() {
      this.props.planStore.toggleModal(false, 'newItemModalIsOpen');
    }

    toggleOnLeave(e) {
      this.props.planStore.toggleOnLeave(e.currentTarget.checked);
    }

    render() {
      const date = format(this.props.planStore.addItemDate ?
        this.props.planStore.addItemDate : new Date(), 'YYYY-MM-DD');

      const form = this.props.planStore.newItemModalIsOpen ? (
        <ShiftForm
          values={{
            startDate: date,
            endDate: date,
          }}
        />
      ) : null;

      return (
        <Modal
          isOpen={this.props.planStore.newItemModalIsOpen}
          contentLabel="Nieuw item modal"
          onRequestClose={() => {
            this.closeModal();
          }}
        >
          <div className="modal-head">
            <div className="modal-head__title">
              Nieuw item
            </div>

            <div className="modal-buttons">
              <button className="btn btn--white modal__close" onClick={this.closeModal}>
                <FontAwesomeIcon icon="times" /> Sluit
              </button>
            </div>
          </div>

          {form}
        </Modal>
      );
    }
  })
);



// WEBPACK FOOTER //
// ./src/components/Grid/NewItemModal.js